// this file added by Bearer Web Developer - change map api
import React, { useEffect } from "react";
import { decodePolyline, Geopoint, TTransportsHistoryInfo } from "../../../api/bearer-api";
import { Location, useAppState } from "../../../states/app-state";
import BearerMapProvider from "../../map/BearerMapApi/BearerMapProvider";
import { AdvancedMarker, Map, useMap } from '@vis.gl/react-google-maps';
import Polyline from "../../map/BearerMapApi/polyline";
import { useThemeMode } from "../../../states/contexts/theme";
import OriginIcon from "../../../assets/images/origin-map.png";
import OriginIconDarkMode from "../../../assets/images/origin-map-dark-mode.svg"; // added by Bearer Web Developer
import DestinationIcon from "../../../assets/images/destination-map.png";
interface IGoogleMapProps { transportHistoryInfo: TTransportsHistoryInfo }
function geoToLocation(point: Geopoint): Location {
    return { lat: point._latitude, lng: point._longitude }
}
function MapApi({ transportHistoryInfo }: IGoogleMapProps) {
    const { theme: themeMode } = useThemeMode(); // added by Bearer Web Developer
    const appState = useAppState();
    const environmentCode = appState.environmentCode;
    const mapId = environmentCode === "STAGING" ? "f4e86786fbb6b3bb" :
        environmentCode === "PRODUCTION" ? "683a7c74fe921546" : "39e429275f5344f2";
    const p_point = React.useMemo(() => decodePolyline(transportHistoryInfo.overview_polyline), [transportHistoryInfo.overview_polyline]);

    const originLocation = React.useMemo(() => geoToLocation(transportHistoryInfo.origin_geopoint), [transportHistoryInfo.origin_geopoint]);
    const destinationLocation = React.useMemo(() => geoToLocation(transportHistoryInfo.destination_geopoint), [transportHistoryInfo.destination_geopoint]);
    const map = useMap();
    const bounds = new google.maps.LatLngBounds();
    p_point?.forEach(p => bounds.extend(p));
    bounds.extend(originLocation);
    bounds.extend(destinationLocation);
    const literalBounds = bounds.toJSON(); // added by Bearer Web Developer
    const options: google.maps.MapOptions = {
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_CENTER,
        } as google.maps.ZoomControlOptions,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        panControl: false,
        rotateControl: false,
        fullscreenControl: false,
        // zoom: 17, // commented by Bearer Web Developer
        // minZoom: 14.4, // added by Bearer Web Developer (zoom not worked so I used minZoom)
        // Update while changing STAGE
        mapId: mapId,
        // ...otherOptions
        draggable: false,
    }
    // modified by Bearer Web Developer start - add useEffect and dependencies
    useEffect(() => {
        if (map) {
            map?.setOptions(options)
            map?.fitBounds(literalBounds);
        }
    }, [map]);
    // modified by Bearer Web Developer end
    return (
        <Map
            colorScheme={themeMode === 'dark' ? 'DARK' : 'LIGHT'} // added by Bearer Web Developer
            style={{ width: '100%', height: '100%' }}
            defaultCenter={{ lat: -37.813628, lng: 144.963058 }}
            defaultBounds={literalBounds}
            disableDefaultUI
        >
            <AdvancedMarker
                anchorLeft="-50%"
                anchorTop="-94%"
                position={originLocation}
            >
                <img
                    src={themeMode === "dark" ? OriginIconDarkMode : OriginIcon} // OriginIconDarkMode and themeMode condition added by Bearer Web Developer}
                    width={21}
                    height={36}
                    alt=""
                />
            </AdvancedMarker>
            <AdvancedMarker
                anchorLeft="-50%"
                anchorTop="-94%"
                position={destinationLocation}
            >
                <img
                    src={DestinationIcon}
                    width={21}
                    height={36}
                    alt=""
                />
            </AdvancedMarker>
            <Polyline
                path={p_point}
                strokeColor={themeMode === "dark" ? "#4ABF12" : '#14438E'} // modified by Bearer Web Developer
                strokeOpacity={1}
                strokeWeight={4}
            />
        </Map>
    )

}
function TransportRouteMapApi({ transportHistoryInfo }: IGoogleMapProps) {
    return (
        <BearerMapProvider>
            <MapApi transportHistoryInfo={transportHistoryInfo} />
        </BearerMapProvider>
    )
}
export default TransportRouteMapApi